export default __webpack_public_path__ + "static/media/project_gm_eshop_0.6dfee7aa.png";